module.exports = __webpack_public_path__ + "img/comparer-yellow-circles.3b600e10.svg";